import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-language-school',
    templateUrl: './language-school.component.html',
    styleUrls: ['./language-school.component.scss']
})
export class LanguageSchoolComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

}